import React from 'react';
import HomeTeamSideBar from './HomeTeamSideBar';
import ProjectSideBar from './ProjectSideBar';

const HomeSideBar = () => {
    return (
        <div className="sidebar">
            {/* <!-- Projects List --> */}
            <ProjectSideBar></ProjectSideBar>

            {/* <!-- Team Members --> */}
            <HomeTeamSideBar></HomeTeamSideBar>
        </div>
    );
};

export default HomeSideBar;